import odontologiaGeneral from "assets/images/specialties/1.png";
import ortodoncia from "assets/images/specialties/2.png";
import odontopediatria from "assets/images/specialties/3.png";
import endodoncia from "assets/images/specialties/6.png";
import cirugiaMaxilofacial from "assets/images/specialties/5.png";
import esteticaDental from "assets/images/specialties/7.jpg";
import periodoncia from "assets/images/specialties/8.png";
import implanteDental from "assets/images/specialties/10.png";

const specialties = [
  {
    id: "odontologia-general",
    title: "Odontología General",
    shortDescription:
      "Atención integral para la salud bucal, desde limpiezas y empastes hasta revisiones preventivas.",
    longDescription:
      "La odontología general es la base de una salud bucal duradera. Nos enfocamos en el diagnóstico, tratamiento y prevención de las afecciones dentales más comunes. Realizamos limpiezas profundas, empastes para caries, selladores y revisiones periódicas para mantener tu sonrisa sana y prevenir problemas futuros. Nuestro enfoque es integral, cuidando de ti y tu familia con la máxima profesionalidad.",
    image: odontologiaGeneral,
  },
  {
    id: "ortodoncia",
    title: "Ortodoncia",
    shortDescription:
      "Alinea tu sonrisa y corrige tu mordida con brackets o alineadores invisibles.",
    longDescription:
      "La ortodoncia no solo mejora la estética de tu sonrisa, sino también la funcionalidad de tu mordida. Ofrecemos tratamientos personalizados que incluyen brackets metálicos tradicionales, brackets estéticos y los modernos alineadores invisibles. Tras un diagnóstico detallado, diseñaremos un plan para alinear tus dientes de forma eficiente y cómoda, mejorando tu salud y confianza.",
    image: ortodoncia,
  },
  {
    id: "odontopediatria",
    title: "Odontopediatría",
    shortDescription:
      "Cuidado dental especializado y amigable para los más pequeños, creando hábitos saludables desde la infancia.",
    longDescription:
      "Sabemos que la primera visita al dentista es crucial. Nuestro equipo de odontopediatría está especializado en tratar a niños y adolescentes en un ambiente cálido, divertido y seguro. Nos enfocamos en la prevención, enseñando técnicas de cepillado y hábitos saludables, y realizamos tratamientos adaptados a sus necesidades para asegurar que crezcan con una sonrisa sana y sin miedos.",
    image: odontopediatria,
  },
  {
    id: "endodoncia",
    title: "Endodoncia",
    shortDescription:
      "Tratamientos de conducto para salvar dientes dañados, eliminando el dolor y preservando tu sonrisa.",
    longDescription:
      "La endodoncia, o tratamiento de conducto, es un procedimiento para salvar un diente que ha sido severamente dañado por caries o una infección. Eliminamos la pulpa dental afectada, limpiamos y sellamos el conducto para eliminar el dolor y evitar la extracción. Utilizamos tecnología avanzada para que el procedimiento sea lo más rápido e indoloro posible, preservando tu diente natural.",
    image: endodoncia,
  },
  {
    id: "cirugia-maxilofacial",
    title: "Cirugía Maxilofacial",
    shortDescription: "Soluciones avanzadas para extracciones complejas, implantes y más.",
    longDescription:
      "El cirujano maxilofacial se especializa en el diagnóstico y tratamiento quirúrgico de problemas en la cara, boca y mandíbula. Realizamos desde extracciones complejas como las muelas del juicio, hasta la colocación de implantes dentales, injertos óseos y tratamiento de patologías. Nuestra experiencia garantiza procedimientos seguros y resultados óptimos.",
    image: cirugiaMaxilofacial,
  },
  {
    id: "estetica-dental",
    title: "Estética Dental",
    shortDescription: "Transforma la apariencia de tu sonrisa con blanqueamientos, carillas y más.",
    longDescription:
      "La estética dental combina arte y ciencia para crear sonrisas espectaculares. Ofrecemos una amplia gama de tratamientos cosméticos, incluyendo blanqueamiento dental profesional, carillas de porcelana para corregir forma y color, contorneado dental y bonding. Analizamos tu rostro y tus deseos para diseñar una sonrisa natural y armoniosa que te haga sentir increíble.",
    image: esteticaDental,
  },
  {
    id: "periodoncia",
    title: "Periodoncia",
    shortDescription: "Cuidado experto de las encías para una base dental sólida y saludable.",
    longDescription:
      "La periodoncia se enfoca en la prevención, diagnóstico y tratamiento de las enfermedades que afectan las encías y las estructuras de soporte de los dientes. Desde limpiezas profundas (curetajes) hasta tratamientos más complejos, nuestro objetivo es mantener tus encías sanas para asegurar la longevidad de tu sonrisa.",
    image: periodoncia,
  },
  {
    id: "implantes-dentales",
    title: "Implantes Dentales",
    shortDescription:
      "Soluciones permanentes y de aspecto natural para reemplazar dientes perdidos.",
    longDescription:
      "Los implantes dentales son la solución más avanzada para reemplazar dientes ausentes. Consisten en un tornillo de titanio que se integra con el hueso, actuando como una raíz artificial sobre la cual se coloca una corona. El resultado es un diente fijo, funcional y estético, que te permite comer, hablar y sonreír con total confianza.",
    image: implanteDental,
  },
];

export default specialties;
